<template>
  <div>
    <h1 class="mb-0">Affiliate Profiles</h1>
    <v-data-table
        :headers="table.headers"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="getAffiliatesProfileCO.data"
        :server-items-length="getAffiliatesProfileCO.count"
        :disable-sort="true"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :page="table.currentPage"
        :items-per-page="table.perPage"
        loading-text="Loading... Please wait"
        fixed-header
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
        :show-select="showSelect"
        @input="onSelect"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search"></DataTableTopBar>
      </template>
      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter type="items"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
                     @search="updateDataInFilters"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <!-- header -->
      <!-- body -->
      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="header.value === 'actions'">
          <v-tooltip v-if="item.isSelectable" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="openDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <a class="no-underline" :href="getCampainsUrl(item)" v-bind="attrs" v-on="on" target="_blank">
                <v-icon color="accent">mdi-chart-pie</v-icon>
              </a>
            </template>
            <span>Campaigns</span>
          </v-tooltip>
        </template>
        <template v-if="header.value === 'currency'">
          <v-tooltip top open-delay="400">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{item.currency}}</span>
            </template>
            <span>{{item.currencyName}}</span>
          </v-tooltip>
        </template>
        <template v-else-if="header.value === 'dateAdded'">
          {{getPrettyDate(item.dateAdded)}}
        </template>
        <template v-else-if="isEntityName(header.value)">
          <a class="entity-link" @click="showCard(item)">{{item[header.value]}}</a>
        </template>
        <template v-else><short-text :text="item[header.value]"></short-text></template>
      </template>
      <!-- body -->
    </v-data-table>
    <DataTableBottomBar
        :showFilter="Object.values(table.filters).find(f => f.selected.length) !== undefined"
        @clearFilters="removeAllFilters"
        v-model="table.heightCounter"
    ></DataTableBottomBar>
    <EditProfile v-model="dialog.open" :item="dialog.item" :title="dialog.title"></EditProfile>
  </div>
</template>

<script>
import EditProfile from "@/components/pages/affiliates/profiles/EditProfile";
import DataTableTopBar from '@/components/common/DataTableTopBar';
import DataTableBottomBar from '@/components/common/DataTableBottomBar';
import {mapGetters} from 'vuex'
import store from "@/store";
import { DateTime } from "luxon";

export default {
  props: {
    showSelect: false,
    showActions: {
      default: true
    },
    hideUnrelated: {
      default: false
    }
  },
  data() {
    return {
      dialog: {
        open: false,
        item: {},
        title: 'New Item'
      },
      table: {
        heightCounter: 45,
        loading: false,
        searchInAffiliates: '',
        awaitingSearch: false,
        currentPage: 1,
        perPage: 25,
        pageChangedByMe: false,
        pageOptions: [10, 25, 50, 100],
        orderBy: '',
        sortColumnsAsc: true,
        headers: [
          { text: 'Aff Name & Id', value: 'affNameId', class: 'color', align: 'center' }, //
          { text: 'Email', value: 'email', align: 'center' }, //
          { text: 'Status', value: 'status', align: 'center' }, //
          { text: 'Currency', value: 'currency', align: 'center' }, //
          { text: 'AM', value: 'affiliateManager', align: 'center' }, //
          { text: 'Billing Cycle', value: 'billingCycle', align: 'center' }, //
          { text: 'Postback Url', value: 'postbackUrl', align: 'center' }, //
          { text: 'Date Added', value: 'dateAdded', align: 'center' }, //
          { text: 'Last Traffic Date', value: 'lastTrafficDate', align: 'center' }, //
          { text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ],
        filters: {
          affNameId: {selected: [], data: []},
          email: {selected: [], data: []},
          status: {selected: [], data: []},
          paymentType: {selected: [], data: []},
          currency: {selected: [], data: []},
          affiliateManager: {selected: [], data: []},
          billingCycle: {selected: [], data: []},
          postbackUrl: {selected: [], data: []},
          dateAdded: {selected: [], data: []},
          lastTrafficDate: {selected: [], data: []},
        }
      },
      filtersMenu: false
    }
  },

  async mounted() {
    if (!this.showActions) {
      const actionsIndex = this.table.headers.findIndex(h => h.value === 'actions');
      if (actionsIndex > -1) {
        this.table.headers.splice(actionsIndex, 1)
      }
    }
    const userSate = this.$store.state.user;
    if (this.hideUnrelated && !userSate.user[0].can('see_all_affiliates_pii')) {
      if (userSate.user[0].can('see_own_affiliates_pii')) {
        this.table.filters.affiliateManager.selected = userSate.user[0].sfl_manager_id ? [userSate.user[0].sfl_manager_id.toString()] : [];
      } else {
        return;
      }
    }
    await this.getTableData()
    this.getFiltersData()
  },

  methods: {
    getPrettyDate(date) {
      return DateTime.fromISO(date).toFormat('MMMM dd, yyyy');
    },
    isEntityName(item) {
      return ['affNameId'].includes(item)
    },
    showCard(item) {
      store.dispatch('cards/ADD', {
        type: 'affiliate',
        title: item.name,
        key: `affiliate-${item.id}`,
        data: item
      })
    },
    getFiltersData() {
      const filters = {};
      for(const name in this.table.filters) {
        // affiliatesApi.getFilter({
        //   filter: filters,
        //   name: name,
        // }).then(res => {
        //   this.table.filters[name].data = res;
        // });
      }
    },
    async getTableData() {
      this.table.loading = true
      this.activateFilters()
      const filters = await this.getFilters();
      await store.dispatch('affiliates/getAffiliatesProfileDataCO', {
        payload: {
          limit: this.table.perPage,
          page: this.table.currentPage,
          orderBy: this.table.orderBy || '',
          orderDirectionAsc: this.table.sortColumnsAsc || false,
          filters: filters || null
        }
      })
      this.table.loading = false
    },
    /** todo add to helper */
    addParamsToLocation(params) {
      const query = JSON.stringify(params) === '{}' ? this.$route.path :
          this.$route.path + '?' + Object.keys(params).map(
              key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          ).join('&')
      history.pushState({},null, query);
    },
    updateFiltersFromQuery() {
      const queryFilters = JSON.parse(this.$route.query.filters);
      for(const name in this.table.filters) {
        if(queryFilters[name]) {
          this.table.filters[name].selected = queryFilters[name];
        }
      }
    },
    async getFilters() {
      const filters = {};
      filters['search'] = (this.table.searchInAffiliates.length > 0) ? this.table.searchInAffiliates : '';
      for(const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0) ?
            `'${this.table.filters[name].selected.join('\',\'')}'` :
            null;
      }

      return filters;
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      this.table.pageChangedByMe = true;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      return await this.getTableData()
    },
    activateFilters() {
      const filtersForQuery = {};
      for (const name in this.table.filters) {
        if(this.table.filters[name].selected.length > 0) {
          filtersForQuery[name] = this.table.filters[name].selected;
        }
      }
      this.addParamsToLocation(
          JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
      );
    },
    async updateDataInFilters(data, modalName) {
      if(modalName) {
        // affiliatesApi.getFilter({
        //   filter: this.table.filters,
        //   name: modalName,
        //   searchFilter: data
        // }).then(res => {
        //   this.table.filters[modalName].data = res;
        // });
      }
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getTableData()
    },
    updateTablePagination(params){
      if (
          (this.table.currentPage === params.page &&
          this.table.perPage === params.itemsPerPage) ||
          this.table.pageChangedByMe
      ) {
        this.table.pageChangedByMe = false;
        return
      }
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      if(this.$route.query.filters) {
        this.updateFiltersFromQuery();
      }
      this.getTableData();
    },
    getCampainsUrl(item) {
      const filters = '?filters=' + encodeURI(JSON.stringify({affNameId: [item.id]}))
      return '/affiliates/campaigns' + filters;
    },
    openDialog(item) {
      this.dialog.item = item;
      this.dialog.title = `Edit ${item.affNameId}'s profile`
      this.dialog.open = true;
    },
    search(value) {
      this.table.searchInAffiliates = value
      this.submitFilter();
    },
    async removeAllFilters() {
      for (let key in this.table.filters) {
        this.table.filters[key].selected = [];
      }
      await this.getTableData()
    },
    onSelect($event) {
      this.$emit('selected', $event)
    }
  },

  computed: {
    ...mapGetters('affiliates', ['getAffiliatesProfileCO'])
  },

  components: {
    EditProfile,
    DataTableTopBar,
    DataTableBottomBar
  },
}
</script>

<style lang="sass">
.co-data-table
  .v-data-table__wrapper
    .v-data-table-header
      th
        white-space: nowrap
.search_btn_wrap
  h1
    margin-bottom: 0
  .search_wrapper
    width: 250px
    padding-bottom: 15px
</style>
